import { render } from "./PlanStep4.vue?vue&type=template&id=7b47fd36&scoped=true"
import script from "./PlanStep4.vue?vue&type=script&lang=js"
export * from "./PlanStep4.vue?vue&type=script&lang=js"

import "./PlanStep4.vue?vue&type=style&index=0&id=7b47fd36&lang=stylus"
import "./PlanStep4.vue?vue&type=style&index=1&id=7b47fd36&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b47fd36"]])

export default __exports__